export class EngagementFinance {
  id: number = 0;
  CategoryId?: number | null;
   CategoryIds?: number[] = []; 
  Category?: string = "";
  Function?: string = "";
  FunctionId?: number | null;
  FunctionIds?: number[] | null;
  FiscalYear?: string | null;
  FiscalYears?: string | null;
  Month?: string | null = "";
  MonthlyProjection?: any;
  FYSpend?: any;
  MRPSpend?: any;
  ActualFY?: any;
  engagementId?: number;
  contractDetailId?: number;
  Contract?:  number ;
  Contracts?: number[] | null;
  Months?: string[] = [];
}
  export class ProjectionsAttachments  {
    Id: number=0;
    FileName?:string;
    FilePath?:string;
    ContractMeetingOccurrenceId: number=0;
    CreatedBy?: number;
    CreatedDate?: Date;
    UpdatedBy?: number;
    UpdatedDate?: Date;
    IsDeleted?: Boolean;
  
  }

  export interface ProjectionUploadedFile {
  id: number;
  name: string;
  fileName: string;
  filePath: string;
  isExisting: boolean;
  file: File | null;
}
